import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M10.8977 1.89877C11.1174 1.67909 11.1174 1.32292 10.8977 1.10324C10.6781 0.883556 10.3219 0.883556 10.1022 1.10324L5.99999 5.20569L1.89776 1.10324C1.67809 0.883562 1.32193 0.883562 1.10226 1.10324C0.882594 1.32292 0.882594 1.6791 1.10226 1.89878L5.2045 6.00122L1.10225 10.1037C0.882583 10.3234 0.882583 10.6795 1.10225 10.8992C1.32192 11.1189 1.67808 11.1189 1.89775 10.8992L5.99999 6.79676L10.1022 10.8992C10.3219 11.1189 10.6781 11.1189 10.8977 10.8992C11.1174 10.6795 11.1174 10.3234 10.8977 10.1037L6.79548 6.00122L10.8977 1.89877Z",
  fill: "#839AAF"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }